$(document).ready(function () {
    if ($('#concours-americana-more').children().length === 0) {
        $('button[data-toggle="concours-americana-more"]').hide();
    }
});
